import { Grid } from "@mui/material";
import {
  KitPickupStyledFormConfirmationLabel,
  KitPickupStyledFormLabel,
} from "./KitPickup.styles";
import { NewKitPickupClinicAccount, NewKitPickupOrder } from "./types";
import { themePalette } from "../../theme";

const KitPickupConfirmation: React.FC<{
  newKitPickupClinicAccount: NewKitPickupClinicAccount;
  newKitPickupOrder: NewKitPickupOrder;
  newOrderCode: string;
}> = ({ newKitPickupClinicAccount, newKitPickupOrder, newOrderCode }) => {
  // Create new date object from ready_timestamp
  const readyTimestamp = new Date(newKitPickupOrder.ready_timestamp);
  const displayReadyDate = readyTimestamp.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
  const displayReadyTime = readyTimestamp.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
  });
  // Customer close time is stored as a military time string, so we need to convert to timestamp to display in standard time
  const customerCloseTimeTimestamp = new Date(
    `${displayReadyDate} ${newKitPickupOrder.customer_close_time}`,
  );
  const displayCustomerCloseTime =
    customerCloseTimeTimestamp.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
    });
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <KitPickupStyledFormLabel
          sx={{ mb: 1, display: "block", color: "green" }}
        >
          Pickup Scheduled Successfully!
        </KitPickupStyledFormLabel>
      </Grid>

      <Grid item xs={12}>
        <KitPickupStyledFormConfirmationLabel
          sx={{ mb: 0.5, display: "block" }}
        >
          Date and Time
        </KitPickupStyledFormConfirmationLabel>
        <div>
          Pickup date: {displayReadyDate}, between {displayReadyTime} and{" "}
          {displayCustomerCloseTime}
        </div>
      </Grid>

      <Grid item xs={12}>
        <KitPickupStyledFormConfirmationLabel sx={{ mb: 1, display: "block" }}>
          Location
        </KitPickupStyledFormConfirmationLabel>
        <div>{newKitPickupClinicAccount.sfname}</div>
        <div>{newKitPickupClinicAccount.billingstreet}</div>
        <div>
          {newKitPickupClinicAccount.billingcity},{" "}
          {newKitPickupClinicAccount.billingstatecode}{" "}
          {newKitPickupClinicAccount.billingpostalcode}
        </div>
      </Grid>

      <Grid item xs={12}>
        <KitPickupStyledFormConfirmationLabel sx={{ mb: 1, display: "block" }}>
          Carrier
        </KitPickupStyledFormConfirmationLabel>
        <div>FedEx</div>
      </Grid>

      <Grid item xs={12}>
        <KitPickupStyledFormConfirmationLabel sx={{ mb: 1, display: "block" }}>
          Pickup #
        </KitPickupStyledFormConfirmationLabel>
        <div>{newOrderCode}</div>
      </Grid>

      <Grid item xs={12} sx={{ mt: 2, color: themePalette.neutral500 }}>
        If you have questions about your pickup or want to make changes, please
        reach out to BillionToOne logistics.
        <div>(217) 807-4707</div>
        <div>logistics@billiontoone.com</div>
      </Grid>
    </Grid>
  );
};

export default KitPickupConfirmation;
